import React from 'react';

export default class CardPresenterGeneral extends React.Component{
  constructor(props){
    super(props)
  };

  render(){
    return(
      <div className="row">
        <div className="col-sm-3">
          <div className="form-group">
            <label>{I18n.t('name_on_card')}</label>
            <p>{this.props.card.first_name.toUpperCase()} {this.props.card.last_name.toUpperCase()}</p>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="payment-log">
            <label className="brand-label">{I18n.t('brand')}/{I18n.t('last_4')}</label>
            <span className={"credit-card-icon small " + this.props.card.brand} ></span>
              <strong>{this.props.card.last_4}</strong>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label>{I18n.t('exp_date')}</label>
            <p>{this.props.card.month}/{this.props.card.year}</p>
          </div>
        </div>
      </div>
    );
  };
};